export default {

           Pagina: "página",
           Ate: "até"

}